export enum BillingMethod {
  PER_EVICTION = 'Per Eviction',
  PER_HOUR = 'Per Hour'
}
